<template>
  <CModal
    alignment="center"
    backdrop="static"
    :visible="notificacoes.status"
  >
    <CModalHeader :close-button="false">
      <CModalTitle>Erro</CModalTitle>
    </CModalHeader>

    <CModalBody>
      <div
        v-for="(erro, index) in errosNormalizados"
        :key="`${index}-${erro}`"
        class="message-body"
      >
        <font-awesome-icon
          class="message-icon"
          icon="fa-solid fa-triangle-exclamation"
        />
        <span class="message-text">{{ erro }}</span>
      </div>
    </CModalBody>

    <CModalFooter>
      <CButton color="danger" @click="updateNotificaErro">
        OK
      </CButton>
    </CModalFooter>
  </CModal>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from '@/store'
import useNotificador from '@/hooks/notificador'

export default defineComponent({
  name: 'NotificacoesErro',

  setup() {
    const { updateNotificaErro } = useNotificador()
    const store = useStore()

    const notificacoes = computed(() => store.state.notificacoes)

    /*
     * O componente antigo fazia:
     *
     * v-for="erro in notificacoes.erros"
     *
     * Quando "erros" recebia uma string, o Vue iterava cada caractere da
     * string. Por isso "promises.map is not a function" aparecia com uma
     * letra em cada linha.
     *
     * Agora qualquer mensagem é convertida para um array antes do v-for.
     */
    const errosNormalizados = computed(() => {
      const erros = notificacoes.value?.erros

      if (Array.isArray(erros)) {
        return erros
          .map((erro) => {
            if (erro === null || erro === undefined) return ''
            if (typeof erro === 'object') {
              return erro.message || erro.error || JSON.stringify(erro)
            }
            return String(erro)
          })
          .filter(Boolean)
      }

      if (erros && typeof erros === 'object') {
        return [
          String(
            erros.message ||
              erros.error ||
              'Ocorreu um erro inesperado.',
          ),
        ]
      }

      if (erros !== null && erros !== undefined && String(erros).trim()) {
        return [String(erros)]
      }

      return ['Ocorreu um erro inesperado.']
    })

    return {
      notificacoes,
      errosNormalizados,
      updateNotificaErro,
    }
  },
})
</script>

<style scoped>
.message-body {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 0.55rem;
  margin-bottom: 0.75rem;
  line-height: 1.45;
}

.message-body:last-child {
  margin-bottom: 0;
}

.message-icon {
  flex: 0 0 auto;
  margin-top: 0.2rem;
}

.message-text {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
}
</style>
